import React from 'react'
import { createBrowserRouter } from 'react-router-dom'

import ErrorPage from '../Pages/Errorpage'
import Home from '../Pages/Home'
import Login from '../Pages/Login/Login'
import Signup from '../Pages/Login/Signup'

import DashboardLayout from '../Layout/DashboardLayout'
import Main from '../Layout/Main'
import Blog from '../Pages/Blog'
import SingleCategory from '../Pages/CategorySection/SingleCategory'
import AddaProduct from '../Pages/Dashboard/AddaProduct'
import AllBuyers from '../Pages/Dashboard/AllBuyers'
import AllSellers from '../Pages/Dashboard/AllSellers'
import AllUsers from '../Pages/Dashboard/AllUsers'
import Dashboard from '../Pages/Dashboard/MyOrders'
import MyProducts from '../Pages/Dashboard/MyProducts'
import PrivateRoute from './PrivateRoute'

const router = createBrowserRouter([
  {
    path: '/',
    element: <Main />,
    errorElement: <ErrorPage></ErrorPage>,
    children: [
      {
        path: '/',
        element: <Home />,
      },
      {
        path: '/login',
        element:<Login></Login> ,
      },
      {
        path: '/signup',
        element:<Signup></Signup> ,
      },
      {
        path:'/blog',
        element:<Blog></Blog>
      },
      {
    path:'/categories/:name',
    element:<PrivateRoute><SingleCategory></SingleCategory></PrivateRoute>,
    loader:({params})=>fetch(`https://app-build-server.vercel.app/categories/${params.name}`)
      }
    ],

  },
  {
    path:'/dashboard',
    element:<PrivateRoute><DashboardLayout></DashboardLayout></PrivateRoute>,
    children:[

{
path:'/dashboard/myorders',
element:<Dashboard></Dashboard>

},
{
path:'/dashboard/allusers',
element:<AllUsers></AllUsers>

},
{
path:'/dashboard/addproduct',
element:<AddaProduct></AddaProduct>

},
{
path:'/dashboard/myproducts',
element:<MyProducts></MyProducts>

},

{
path:'/dashboard/allsellers',
element:<AllSellers></AllSellers>

},

{
path:'/dashboard/allbuyers',
element:<AllBuyers></AllBuyers>

},







    ]
  }
])

export default router
